import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import OrderConfirmedModal from "../modal/orderConfirm";
import { fetchCartData } from "../redux/actions/cartData";
import { useDispatch, useSelector } from "react-redux";
import { decrementQuantityOfCartProduct, incrementQuantityOfCartProduct } from "../service/Incre&DecrrQuantityINCart";
import { removeFromCart } from "../service/addToCart";
import { MdOutlineKeyboardBackspace } from "react-icons/md";
import axios from "axios";
import formatPaymentMethod from "../components/comman/formatePaymentMethod";
const Base_Url = process.env.REACT_APP_BASE_URL;
function formatNumber(value) {
    const num = Number(value);
    return num % 1 === 0 ? num : num.toFixed(2);
  }
export default function PaymentPage({ selectedAddress, goBack }) {
  const [address, setAddress] = useState(null);

useEffect(() => {
  const fetchAddressDetails = async () => {
    if (!selectedAddress) return;
    
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(
        `${Base_Url}/api/address/getAddress/${selectedAddress}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data.success) {
        setAddress(res.data.data); 
      } else {
        toast.error(res.data.message || "Failed to fetch address details");
      }
    } catch (err) {
      console.error("❌ Fetch address error:", err);
      toast.error(err.response?.data?.message || "Failed to load address details");
    }
  };

  fetchAddressDetails();
}, [selectedAddress]);

  const [selectedMethod, setSelectedMethod] = useState("Credit / Debit Card");
  const methods = [
    "debit_card",
    "netbanking",
    "upi",
    "cod",
  ];
  const [cardDetails, setCardDetails] = useState({
  number: "",
  holder: "",
  expiry: "",
  cvv: "",
  });
const [upiId, setUpiId] = useState("");
const [selectedBank, setSelectedBank] = useState("");

const dispatch=useDispatch();
const {cartData=[], carterror,}=useSelector((state)=>state.cartState);

useEffect(()=>{     
  dispatch(fetchCartData());         
},[dispatch]);

  const getSubtotal = () =>
    cartData.reduce((sum, item) => sum + item.product?.originalPrice * item.quantity, 0);

  const getTotal = () =>
    cartData.reduce((sum, item) => sum + item.product?.discountedPrice * item.quantity, 0);


const isPaymentValid = () => {
  if (selectedMethod === "Credit / Debit Card") {
    const { number, holder, expiry, cvv } = cardDetails;
    return number && holder && expiry && cvv;
  } else if (selectedMethod === "UPI Payment") {
    return upiId.trim() !== "";
  } else if (selectedMethod === "Net Banking") {
    return selectedBank.trim() !== "";
  }
  return true; 
};

const [showOrderConfirmedModal, setShowOrderConfirmedModal] = useState(false);

  const UpdateQuantity = (id, type,selectedColor,selectedSize) => {
    if (type === "increment") {
      dispatch(incrementQuantityOfCartProduct(id,selectedColor,selectedSize));
    } else if (type === "decrement") {
      dispatch(decrementQuantityOfCartProduct(id,selectedColor,selectedSize));
    }
  };

  const RemoveFromCart=(productId,selectedColor,selectedSiz)=>{
    dispatch(removeFromCart(productId,selectedColor,selectedSiz));
  }

useEffect(() => {
  const fetchAddressDetails = async () => {
    if (!selectedAddress) return;
    
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(
        `${Base_Url}/api/address/getAddress/${selectedAddress}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data.success) {
       setAddress(res.data.data);
      } else {
        toast.error(res.data.message || "Failed to fetch address details");
      }
    } catch (err) {
      console.error("❌ Fetch adress error:", err);
      toast.error(err.response?.data?.message || "Failed to load address details");
    }
  };

  fetchAddressDetails();
}, [selectedAddress]);

const formatAddress = (addr) => {
  if (!addr) return "";
  return [
    addr.buildingBlock ? addr.buildingBlock.toUpperCase() : "",
    addr.flatNo || "",
    addr.buildingName || "",
    addr.landmark || "",
    addr.streetName || "",
    addr.city || "",
    addr.pincode || ""
  ]
    .filter(Boolean) 
    .join(", ");
};

const handleConfirmOrder = async() => {
  if (!isPaymentValid()) {
    toast.warning("Please complete payment details before proceeding.");
    return;
  }
  try {
      const token = localStorage.getItem("token");
      const orderItems = cartData.map(item => ({
        productId: item.product.id,
        quantity: item.quantity
      }));
      const res = await axios.post(
        `${Base_Url}/api/productOrder/placeOrder`,
        { addressId:selectedAddress,
          paymentMethod:selectedMethod, 
          items:orderItems },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success(res.data.message || "Your order placed successfully");
      cartData.forEach(item => {
        dispatch(removeFromCart(item.product.id, item.selectedColor, item.selectedSize,false));
      });
      setShowOrderConfirmedModal(true);

    } catch (err) {
      console.error("Failed to place order", err);
      if (err.response?.status === 404) {
        toast.info(err.response.data?.message || "Product not found in cart");
      } else if(err.response?.status === 400)
      {
        toast.info(err.response.data?.message);
      } else{
        toast.error(err.response?.data?.message || "Failed to place order");
      }
    }
  
};

if(carterror)
  {
    return(
      <p className="text-red-600">Cart error : {carterror}</p>
    );
}

  return (
    <>
    <div className="flex flex-col md:flex-row border space-x-0 space-y-5 md:space-x-5 md:space-y-0  xl:space-x-7 border-gray-500 p-3 md:p-7 xl:p-8 rounded-lg w-full items-start">
         <div className="w-full md:w-1/2 ">

            <div className="flex flex-row items-center space-x-2 mb-4">
              <button 
                className=""
                onClick={()=>goBack()}
              >
                  <MdOutlineKeyboardBackspace className="text-base lg:text-lg text-black" />
              </button>              
              <h2 className="text-sm md:text-base xl:text-xl font-semibold">Product Details</h2>
            </div>
            
            <div className="grid grid-cols-1 gap-5 w-full">
            {cartData.map((item) => (
                <div key={item.id} className="bg-[#FFF1F133] p-3 md:p-5 rounded shadow flex flex-col justify-between">                        
                    <div className="flex flex-row justify-between items-start gap-4 w-full">
                        <div className="relative">
                            <img src={item.product?.images?.[0].image} alt={item.product?.productName}  className="w-24 h-24 object-contain rounded" />
                        </div>
                        <div className="flex flex-col space-y-1">
                            <p className="font-semibold text-xs md:text-sm xl:text-base">
                              {item.product?.productName} {item.product?.model} {item.product?.category?.name}
                            </p>
                            <div className="flex flex-col items-start text-xs md:text-sm py-2">
                              <p className="text-xs md:text-sm xl:text-base">
                                Color: {item.selectedColor || "N/A"}
                              </p>
                              <p className="text-xs md:text-sm xl:text-base">
                                Size: {item.selectedSize|| "N/A"}
                              </p>
                            </div>
                            {/* <p className="text-xs md:text-sm xl:text-base">{(item.description)}</p>        */}
                            <div className="flex flex-row justify-between items-center">
                            <div className="flex items-center rounded overflow-hidden w-auto border border-green-700">
                            <button
                              onClick={() => UpdateQuantity(item.product?.id, "decrement",item.selectedColor,item.selectedSize)}
                              className="px-2 "
                              disabled={item.quantity <= 1}
                            >
                              -
                            </button>
                            <span className="px-3">{item.quantity}</span>
                            <button
                              onClick={() => UpdateQuantity(item.product?.id, "increment",item.selectedColor,item.selectedSize)}
                              className="px-2 "
                            >
                              +
                            </button>
                            </div>
                          </div>
                        </div>
                        <div className="flex flex-col space-y-3">
                            <p className="text-gray-800 ">₹{formatNumber(item.product?.discountedPrice)}</p>
                            <p className="font-semibold text-gray-400 line-through">₹{formatNumber(item.product?.originalPrice)}</p>

                            
                            <button
                            className="text-xs md:text-sm text-[#A63F40] border border-[#A63F40] rounded-lg px-2 py-1"
                            onClick={() => RemoveFromCart(item.product?.id,item.selectedColor,item.selectedSize)}
                            >
                                Remove
                            </button>

                        </div>
                    </div>
                </div>
            ))}
            </div> 

            <div className="flex flex-col space-y-3 mt-5 md:mt-8">
                <h2 className="text-sm md:text-base xl:text-xl font-semibold ">Delivery Location</h2>
                <p className="border border-gray-300 text-black p-2 rounded bg-gray-100 text-xs md:text-sm xl:text-base">
                  {formatAddress(address)}
                </p>
            </div>
         </div>

      <div className="w-full md:w-1/2">
      <h2 className="text-sm md:text-base xl:text-xl font-semibold mb-4">Payment Method</h2>
      <div className="flex flex-col lg:flex-row divide-y lg:divide-x border border-red-800 rounded overflow-hidden">
        {methods.map((method) => (
          <div
            key={method}
            onClick={() => setSelectedMethod(method)}
            className={`flex-1 text-center py-2 cursor-pointer text-sm md:text-base  font-medium transition-all duration-200 ${
              selectedMethod === method
                ? "bg-[#A63F40] text-white border-[#A63F40]"
                : "bg-white text-gray-700"
            }`}
          >
            {formatPaymentMethod(method)}
          </div>
        ))}
      </div>
     
      {selectedMethod === "debit_card" && (
        <div className="mt-4 grid grid-cols-1 gap-4 border border-gray-300 shadow-md rounded px-5 py-5">
          <input
            type="text"
            placeholder="Card Number"
            value={cardDetails.number}
            onChange={(e) => setCardDetails({ ...cardDetails, number: e.target.value })}
            className="border rounded px-3 py-2 w-full border-gray-500 focus:outline-none"
          />
          <input
            type="text"
            placeholder="Card Holder Name"
            value={cardDetails.holder}
            onChange={(e) => setCardDetails({ ...cardDetails, holder: e.target.value })}
            className="border rounded px-3 py-2 w-full border-gray-500 focus:outline-none"
          />
          <input
            type="text"
            placeholder="Expiry Date (MM/YY)"
            value={cardDetails.expiry}
            onChange={(e) => setCardDetails({ ...cardDetails, expiry: e.target.value })}
            className="border rounded px-3 py-2 w-full border-gray-500 focus:outline-none"
          />
          <input
            type="password"
            placeholder="CVV"
            value={cardDetails.cvv}
            onChange={(e) => setCardDetails({ ...cardDetails, cvv: e.target.value })}
            className="border rounded border-gray-500 focus:outline-none px-3 py-2 w-full"
          />
        </div>
      )}

      {selectedMethod === "netbanking" && (
        <div className="mt-4 border border-gray-300 shadow-md rounded px-5 py-5">
          <input
            type="text"
            placeholder="Enter UPI ID"
            value={upiId}
            onChange={(e) => setUpiId(e.target.value)}
            className="border rounded border-gray-500 focus:outline-none px-3 py-2 w-full"
          />
          <button className="bg-[#A63F40] w-full mt-3 py-2 text-center text-white rounded-md text-xs md:text-sm xl:text-base">Verify</button>
        </div>
      )}

      {selectedMethod === "upi" && (
        <div className="mt-4 border border-gray-300 shadow-md rounded px-2 py-5">
          <select 
            value={selectedBank}
            onChange={(e) => setSelectedBank(e.target.value)}
            className="border border-gray-500 focus:outline-none rounded px-3 py-2 w-full text-xs md:text-sm xl:text-base">
            <option value="">Select Bank</option>
            <option>HDFC Bank</option>
            <option>ICICI Bank</option>
            <option>State Bank of India</option>
            <option>Axis Bank</option>
          </select>
        </div>
      )}

      {selectedMethod === "cod" && (
        <div className="mt-4 text-sm xl:text-base text-gray-600 border border-gray-300 shadow-md rounded px-2 py-5">
          <p className="text-center">Pay with cash when your order is delivered to your doorstep.</p>
        </div>
      )}

      <h2 className="text-sm md:text-base xl:text-xl font-semibold mb-4 mt-6">Payment Summary</h2>
      <div className="w-full lg:w-2/3 border border-gray-300 shadow-md rounded px-5 py-5 grid grid-cols-2 gap-x-2 gap-y-2 text-sm md:text-sm xl:text-base">
          <p>Total Item:</p>
          <p>{cartData.length} items</p>
          <p>Subtotal amount:</p>
          <p>₹{getSubtotal().toLocaleString()}</p>
          <p>Discount Amount:</p>
          <p>-₹{(getSubtotal() - getTotal()).toLocaleString()}</p>
          <hr className="col-span-2"/>
          <p>Total (Payable amount):</p>
          <p>₹{getTotal().toLocaleString()}</p>
      </div>
      </div>    
    </div>

    <div className="flex flex-row justify-between px-5 md:px-20 xl:px-36  mt-5 md:mt-10 text-xs md:text-sm xl:text-base">
      <button 
        className="bg-[#A63F40] rounded-lg py-2 text-white w-full text-center"
        onClick={handleConfirmOrder}>
          Pay & Confirm Order
      </button>
    </div>


    {showOrderConfirmedModal && (
    <OrderConfirmedModal  
      onClose={() => setShowOrderConfirmedModal(false)} 
    />
    )}

    </>
  );
}
